var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    { ref: "editForm" },
    [
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailInfo",
          attrs: { title: "안전사고 기본정보" },
        },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.editable &&
                          !_vm.param.isApprovePop &&
                          !this.standardInfo.sysApprovalRequestId,
                        expression:
                          "editable&&!param.isApprovePop&&!this.standardInfo.sysApprovalRequestId",
                      },
                    ],
                    attrs: {
                      isSubmit: _vm.isDeleteAuth,
                      url: _vm.deleteAuthUrl,
                      param: _vm.standardInfo,
                      mappingType: "PUT",
                      label: "삭제",
                      icon: "delete",
                      auth: "SAFHEA",
                    },
                    on: {
                      beforeAction: _vm.deleteAuthAccident,
                      btnCallback: _vm.deleteAuthCallback,
                    },
                  }),
                  _vm.editable && !_vm.param.isApprovePop
                    ? _c("c-appr-btn", {
                        ref: "appr-btn",
                        attrs: {
                          name: "process-accident-btn",
                          editable: _vm.editable,
                          approvalInfo: _vm.approvalInfo,
                        },
                        on: {
                          beforeApprAction: _vm.saveDataAppr,
                          callbackApprAction: _vm.approvalCallback,
                          requestAfterAction: _vm.getStdInfo,
                        },
                      })
                    : _vm._e(),
                  _c("c-update-btn", {
                    attrs: {
                      name: "updateBtn",
                      data: _vm.param.updateBtnProps.data,
                      btnEditable: _vm.param.updateBtnProps.btnEditable,
                      flagCondition: _vm.param.updateBtnProps.flagCondition,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("c-label-text", {
                  attrs: {
                    title: "사고번호",
                    value: _vm.standardInfo.accidentNo,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("c-label-text", {
                  attrs: {
                    title: "사고명",
                    value: _vm.standardInfo.accidentName,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("c-label-text", {
                  attrs: {
                    title: "재해일시",
                    value: _vm.standardInfo.occurrenceDate,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("c-label-text", {
                  attrs: {
                    title: "발생원인",
                    value: _vm.standardInfo.occurrenceModeLargeName,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm",
          attrs: { title: "계획 및 담당자의견" },
        },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  !_vm.disabled && _vm.editable
                    ? _c("c-btn", {
                        attrs: {
                          url: _vm.updateUrl,
                          isSubmit: _vm.isSave,
                          param: _vm.accidentInfo,
                          mappingType: "PUT",
                          label: "저장",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveAccident,
                          btnCallback: _vm.saveCallback,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-9 col-sm-9 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-textarea", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    rows: 5,
                    label: "단기계획",
                    name: "shortPlan",
                  },
                  model: {
                    value: _vm.accidentInfo.shortPlan,
                    callback: function ($$v) {
                      _vm.$set(_vm.accidentInfo, "shortPlan", $$v)
                    },
                    expression: "accidentInfo.shortPlan",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-textarea", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    rows: 5,
                    label: "중장기 계획",
                    name: "longPlan",
                  },
                  model: {
                    value: _vm.accidentInfo.longPlan,
                    callback: function ($$v) {
                      _vm.$set(_vm.accidentInfo, "longPlan", $$v)
                    },
                    expression: "accidentInfo.longPlan",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-textarea", {
                  attrs: {
                    editable: _vm.editable,
                    disabled: _vm.disabled,
                    rows: 5,
                    label: "담당자 의견",
                    name: "managerOpinion",
                  },
                  model: {
                    value: _vm.accidentInfo.managerOpinion,
                    callback: function ($$v) {
                      _vm.$set(_vm.accidentInfo, "managerOpinion", $$v)
                    },
                    expression: "accidentInfo.managerOpinion",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "tableImpr",
          attrs: {
            title: "개선 목록",
            columns: _vm.gridImpr.columns,
            data: _vm.accidentInfo.accidentImproveModelList,
            gridHeight: _vm.gridImpr.height,
            merge: _vm.gridImpr.merge,
            selection: "multiple",
            rowKey: "causesNo",
            usePaging: false,
            isExcelDown: false,
            filtering: false,
            columnSetting: false,
            editable: _vm.editable && !_vm.disabled,
          },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  props.row["sopImprovementIds"] && props.row["ibmStepNames"]
                    ? _vm._l(
                        _vm.$comm.ibmTagItems(props.row, _vm.colorItems),
                        function (item, index) {
                          return _c(
                            "q-chip",
                            {
                              key: index,
                              staticStyle: {
                                "margin-bottom": "4px !important",
                              },
                              attrs: {
                                color: item.color,
                                clickable: true,
                                "text-color": "white",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.linkClick(item, props.row)
                                },
                              },
                            },
                            [
                              _vm._v(" " + _vm._s(item.title) + " "),
                              _c("c-assess-tooltip", {
                                attrs: {
                                  ibmTooltip: item.ibmTooltip,
                                  ibmClassCd: item.ibmClassCd,
                                },
                              }),
                            ],
                            1
                          )
                        }
                      )
                    : _vm._e(),
                  props.row.editFlag !== "C"
                    ? _c(
                        "div",
                        [
                          _c(
                            "q-btn-group",
                            {
                              staticClass: "ColumInnerBtnGroup",
                              attrs: { outline: "" },
                            },
                            [
                              _vm.editable && !_vm.disabled
                                ? _c(
                                    "q-btn",
                                    {
                                      staticClass: "ColumInnerBtn",
                                      attrs: {
                                        icon: "add",
                                        color: "red-6",
                                        "text-color": "white",
                                        align: "center",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.innerBtnClicked(
                                            col,
                                            props,
                                            "1"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("q-tooltip", [
                                        _vm._v(" 개선요청등록 "),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.editable && !_vm.disabled
                                ? _c(
                                    "q-btn",
                                    {
                                      staticClass: "ColumInnerBtn",
                                      attrs: {
                                        icon: "add",
                                        color: "light-blue",
                                        "text-color": "white",
                                        align: "center",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.innerBtnClicked(
                                            col,
                                            props,
                                            "2"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("q-tooltip", [
                                        _vm._v(" 즉시조치등록 "),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          label: "추가",
                          showLoading: false,
                          icon: "add",
                        },
                        on: { btnClicked: _vm.add },
                      })
                    : _vm._e(),
                  _vm.editable &&
                  !_vm.disabled &&
                  _vm.accidentInfo.accidentImproveModelList.length > 0
                    ? _c("c-btn", {
                        attrs: {
                          url: _vm.updateCauseUrl,
                          isSubmit: _vm.isSave2,
                          param: _vm.accidentInfo.accidentImproveModelList,
                          mappingType: "PUT",
                          label: "저장",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveAccident2,
                          btnCallback: _vm.saveCallback,
                        },
                      })
                    : _vm._e(),
                  _vm.editable &&
                  !_vm.disabled &&
                  _vm.accidentInfo.accidentImproveModelList.length > 0
                    ? _c("c-btn", {
                        attrs: {
                          label: "삭제",
                          showLoading: false,
                          icon: "remove",
                        },
                        on: { btnClicked: _vm.removeImpr },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }